import React, { Component } from 'react'
import {  Tab, Tabs } from "react-bootstrap";
import NeedHelp from '../Elements/NeedHelp';
import { getInitialRoute } from '../../../../../../utils';
import CheckBoxField from '../Elements/CheckboxField';
import InputField from '../Elements/InputField';
import { createFeedAction } from '../../../../../../actions/addFeedActions';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';

class Flickr extends Component {
  state = {
    hashtag: "",
    handle: "",
    moderation: false,
    error: false,
    handleError: false,
    filterType: "Hashtag",
    loading: false,
    errorMsg: 'This field is required',
  }

  componentDidMount() {
    this.props.onFilterNameChange(this.state.filterType)
  }

  onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, handleError: false })
  onManuallyApproveChange = (value) => this.setState({ moderation: value })

  onSubmit = () => {
    const { hashtag,handle, manuallyApprove,filterType } = this.state;
    const { navigation, feedInfo, hideAddfeed, wallId } = this.props;

    if (filterType == 'Hashtag' && hashtag == '') {
      this.setState({ error: true });
  } else if (filterType == 'Handle' && handle == '') {
      this.setState({ handleError: true });
  } else {

      this.setState({ error: false, handleError:false, loading: true })

      const ftr = feedInfo && feedInfo.length && feedInfo[0].networkTab && feedInfo[0].networkTab.length ? feedInfo[0].networkTab.findIndex(f => f.feedtype == filterType) : null
      const filterId = feedInfo[0]?.networkTab[ftr]?.filter;


      var obj = {
        wallId: wallId,
        networkId: 6,
        moderation: manuallyApprove ? 1 : 0,
        connetedAccount: 0,
        feedType: filterId,
        account: 0,
        filter: filterId,
      }

      if (filterId == 1) obj['field1'] = handle.split('@').join('')
      if (filterId == 2) {
        obj['field2'] = hashtag.split('#').join('')
      } 

      createFeedAction(obj,6,(feedId)=>this.setState({loading:false},()=>{ 
          if(feedId){
              navigation(`/moderation/index/${wallId}`);
              hideAddfeed();
          }  
      }));
    }
  }

  needSupportLinks = (filterType) => {
    if (getInitialRoute() === 'widget') {
      switch (filterType) {
        case 'Hashtag':
          return ['https://player.vimeo.com/video/704109947', 'https://taggbox.com/support/how-to-embed-flickr-gallery-on-website/']
        case 'Handle':
          return ['https://player.vimeo.com/video/704108789', 'https://taggbox.com/support/how-to-embed-flickr-gallery-on-website/']
        default:
          return ['https://player.vimeo.com/video/704109947', 'https://taggbox.com/support/how-to-embed-flickr-gallery-on-website/']
      }
    } else {
      switch (filterType) {
        case 'Hashtag':
          return ['https://vimeo.com/537172746/283a7eccf6', '']
        case 'Handle':
          return ['https://vimeo.com/541616869/63ad456a74', '']
        default:
          return ['https://vimeo.com/537172746/283a7eccf6', '']
      }
    }
  }
 

  render() {
    const { hashtag, handle, moderation, error, errorMsg, filterType, loading, handleError } = this.state
    return (
      <div className="form-body create_feed_wt">
        <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details createFeedInsta personalizePopup">
          <Tabs defaultActiveKey="Hashtag" id="VimeoFeedTab" onSelect={(e) => this.setState({ filterType: e },()=>{ this.props.onFilterNameChange(e)})} className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3">
            <Tab eventKey={'Hashtag'} className="nav-link p-0" title={<span>{'Hashtag(#)'}</span>}>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className={`fas fa-hashtag`}></i>
                    </span>
                  </div>
                  <InputField name={"hashtag"} id='flickr_hashtag' className={`mycheck form-control`} placeholder="Enter Hashtag" value={hashtag} onChangeHandler={(e) => { this.onTextChange(e)}} />
                </div>
                {error ? <span id="feedsfield2error" className="errorMessage required">{errorMsg}</span> : null}
              </div>
              <div className="hideforBSearch">
                <div className="checkbox-inline">
                  <CheckBoxField isChecked={moderation} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_hashtag" />
                </div>
              </div>
            </Tab>

            <Tab eventKey={'Handle'} className="nav-link p-0" title={<span>{'Handle(@)'}</span>}>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className={`fas fa-at`}></i>
                    </span>
                  </div>
                  <InputField name={"handle"} id='flickr_handle' className={`mycheck form-control`} placeholder="Enter Handle" value={handle} onChangeHandler={(e) =>{ this.onTextChange(e)}} />
                </div>
                {handleError ? <span id="feedsfield2error" className="errorMessage required">{errorMsg}</span> : null}
              </div>
              <div className="hideforBSearch">
                <div className="checkbox-inline">
                  <CheckBoxField isChecked={moderation} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_handle" />
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
        <div className="form-actions">
          <div className="f-between flex-wrap border-top pt-3 mt-4">
            <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filterType)[0]} supportLink={this.needSupportLinks(filterType)[1]} />
            <SubmitFeedRequest loading={loading} onBack={this.props.onBack} onSubmit={this.onSubmit}/>
          </div>
        </div>
      </div>
    )
  }
}

export default Flickr